import PropTypes from "prop-types";
import React from "react";
import withReduxProvider from "web/react/redux-provider";
import { connect } from "react-redux";
import FeedsSeoSizeGuide from "./feeds-seo-size-guide/feeds-seo-size-guide";
import FeedsSeoMostWanted from "./feeds-seo-most-wanted/feeds-seo-most-wanted";
import FeedsSeoCareInformation from "./feeds-seo-care-information/feeds-seo-care-information";
import FeedsSeoFaq from "./feeds-seo-faq/feeds-seo-faq";
import styles from "./feeds-seo-content.css";

function mapStateToProps(state) {
    const { visible } = state.feedSeoContentReducer;
    return {
        showContent: visible,
    };
}

function FeedsSeoContent({ showContent, expandedContents }) {
    const {
        introduction,
        most_wanted: mostWanted,
        sizing_chart: sizingChart,
        care_information: careInformation,
        faq,
    } = expandedContents;

    if (!showContent) {
        return <div />;
    }

    let introTitle = null;
    if (introduction.title) {
        introTitle = <h2 className={styles.introTitle}>{introduction.title}</h2>;
    }

    let introBody = null;
    if (introduction.body) {
        introBody = (
            <div
                className={styles.introBody}
                dangerouslySetInnerHTML={{ __html: introduction.body }}
            />
        );
    }

    return (
        <div className={styles.feedsSeoContent}>
            {introTitle}

            {introBody}

            <FeedsSeoMostWanted mostWanted={mostWanted} />

            <FeedsSeoSizeGuide sizingChart={sizingChart} />

            <FeedsSeoCareInformation careInformation={careInformation} />

            <FeedsSeoFaq faq={faq} />
        </div>
    );
}

FeedsSeoContent.propTypes = {
    showContent: PropTypes.bool,
    expandedContents: PropTypes.shape({
        introduction: PropTypes.object,
        sizing_chart: PropTypes.object,
        most_wanted: PropTypes.object,
        care_information: PropTypes.object,
        faq: PropTypes.object,
    }),
};

FeedsSeoContent.defaultProps = {
    showContent: true,
};

export default withReduxProvider(connect(mapStateToProps)(FeedsSeoContent));
